import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=e5d673fe&scoped=true&"
import script from "./MainTable.vue?vue&type=script&lang=js&"
export * from "./MainTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d673fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5d673fe')) {
      api.createRecord('e5d673fe', component.options)
    } else {
      api.reload('e5d673fe', component.options)
    }
    module.hot.accept("./MainTable.vue?vue&type=template&id=e5d673fe&scoped=true&", function () {
      api.rerender('e5d673fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/project-detail/BuildingList/MainTable.vue"
export default component.exports